<div class="po-type-form">
    <div class="alert alert-info small mb-3" role="status">
        <strong>Proof of concept:</strong> Credit Card PO — extra fields below are for workflow discussion. Data is not saved to Vista yet (same as
        other wizard line-detail fields until backend support is added).
    </div>

    <h6 class="form-section-title">Job Cost</h6>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="ccJcCo">JC Co</label>
            <input type="number" class="form-control" [(ngModel)]="item().jcCo" name="ccJcCo" id="ccJcCo" />
        </div>
        <div class="col-sm-5 col-6 form-group">
            <label for="ccJob">Job</label>
            <input type="text" class="form-control" [(ngModel)]="item().job" name="ccJob" id="ccJob" />
        </div>
        <div class="col-sm-4 col-12 form-group">
            <label for="ccPhase">Phase</label>
            <input type="text" class="form-control" [(ngModel)]="item().phase" name="ccPhase" id="ccPhase" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3 col-6 form-group">
            <label for="ccCostType">CT</label>
            <input type="number" class="form-control" [(ngModel)]="item().costType" name="ccCostType" id="ccCostType" />
        </div>
    </div>

    <h6 class="form-section-title mt-3">Card &amp; merchant (POC)</h6>
    <div class="row">
        <div class="col-sm-6 col-12 form-group">
            <label for="ccCardholder">Cardholder name</label>
            <input type="text" class="form-control" [(ngModel)]="item().cardholderName" name="ccCardholder" id="ccCardholder" autocomplete="off" />
        </div>
        <div class="col-sm-3 col-6 form-group">
            <label for="ccLast4">Card last 4</label>
            <input
                type="text"
                class="form-control"
                [(ngModel)]="item().cardLastFour"
                name="ccLast4"
                id="ccLast4"
                maxlength="4"
                pattern="[0-9]{0,4}"
                inputmode="numeric"
                autocomplete="off"
                placeholder="0000"
            />
        </div>
        <div class="col-sm-3 col-6 form-group">
            <label for="ccTxnDate">Transaction date</label>
            <wj-input-date [(ngModel)]="item().transactionDate" name="ccTxnDate" id="ccTxnDate" [isRequired]="false"></wj-input-date>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12 form-group">
            <label for="ccMerchant">Merchant / payee (free text)</label>
            <input
                type="text"
                class="form-control"
                [(ngModel)]="item().merchantOrPayee"
                name="ccMerchant"
                id="ccMerchant"
                placeholder="If different from vendor above"
            />
        </div>
        <div class="col-sm-6 col-12 form-group">
            <label for="ccCategory">Expense category (discussion)</label>
            <select class="form-control" [(ngModel)]="item().expenseCategory" name="ccCategory" id="ccCategory">
                @for (opt of expenseCategoryOptions; track opt) {
                    <option [value]="opt">{{ opt || '(select)' }}</option>
                }
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-12 form-group">
            <label for="ccPurpose">Business purpose / memo</label>
            <textarea
                class="form-control"
                [(ngModel)]="item().businessPurpose"
                name="ccPurpose"
                id="ccPurpose"
                rows="2"
                placeholder="Why was this purchase made?"
            ></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-12 form-group d-flex align-items-center">
            <div class="form-check mb-0">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item().isPersonalExpense" name="ccPersonal" id="ccPersonal" />
                <label class="form-check-label" for="ccPersonal">Flag as personal / needs reimbursement discussion</label>
            </div>
        </div>
    </div>

    <h6 class="form-section-title mt-3">Material</h6>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="ccMaterial">Material</label>
            <input type="text" class="form-control" [(ngModel)]="item().material" name="ccMaterial" id="ccMaterial" />
        </div>
        <div class="col-sm-4 col-6 form-group">
            <label for="ccVendorMat">Vendor Mat</label>
            <input type="text" class="form-control" [(ngModel)]="item().vendorMaterial" name="ccVendorMat" id="ccVendorMat" />
        </div>
        <div class="col-sm-2 col-6 form-group d-flex align-items-end">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item().receiving" name="ccReceiving" id="ccReceiving" />
                <label class="form-check-label" for="ccReceiving">Receiving</label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4 col-6 form-group">
            <label for="ccTicket">Ticket</label>
            <input type="text" class="form-control" [(ngModel)]="item().ticket" name="ccTicket" id="ccTicket" />
        </div>
    </div>

    <app-po-common-fields [item]="item()" [glAccountReadonly]="true"></app-po-common-fields>
</div>
